import React, { FC, useMemo } from 'react';
import { NodeViewWrapper, NodeViewProps } from '@tiptap/react';
import { Node as ProseMirrorNode } from '@tiptap/pm/model';
import { StandardLinkExtensionRenderOptions } from '../plugins/StandardLink';
import { LocalLibrary } from '@mui/icons-material';
import { useGuideCmsContext } from '../../../GuideCmsContext';

const renderText = (node: ProseMirrorNode) => {
  return node.attrs.standardName;
};

export const StandardLinkView: FC<NodeViewProps> = (props) => {
  const { getStandardTitle } = useGuideCmsContext();
  const title = useMemo(() => getStandardTitle(props.node.attrs.standardId), [props.node.attrs.standardId, getStandardTitle]);
  return (
    <NodeViewWrapper className="react-component" as={'span'}>
      <span className="link link-standard" title={title ?? 'Lenke til standard'}>
        <span className="link-icon">
          <LocalLibrary />
        </span>{' '}
        {props.node.attrs.standardName}
      </span>
    </NodeViewWrapper>
  );
};

export const getStandardLinkExtensionRenderOptions = (): StandardLinkExtensionRenderOptions => {
  return {
    viewComponent: StandardLinkView,
    renderText: (node) => renderText(node),
  };
};
